import FormGroupWithTooltip from '@/components/common/FormGroup/FormGroupWithTooltip';
import Select from '@/components/common/Select/Select';
import { TrackType } from '@/data/models/track';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { TrackEditViewTemplateProps } from '../TrackEditViewTemplate';
import { BaseFormGroupProps } from './types';

type Props = Pick<
  TrackEditViewTemplateProps,
  | 'handleInput'
  | 'baseMixedTrack'
  | 'trackData'
  | 'isMultipleTrack'
  | 'areNewMultipleTracks'
> &
  BaseFormGroupProps & {
    trackKey: string;
  };

export default function TrackTypeFormGroup({
  trackKey,
  trackData,
  baseMixedTrack,
  readonly,
  disabled,
  areNewMultipleTracks,
  isMultipleTrack,
  handleInput,
}: Props) {
  const { t } = useTranslation();
  const trackTypeOptions = [
    {
      label: t('track.trackType.videoAndAudio'),
      value: TrackType.VideoAndAudio,
    },
    {
      label: t('track.trackType.audioOnly'),
      value: TrackType.AudioOnly,
    },
  ];
  const isMixed =
    baseMixedTrack?.trackType?.isMixed &&
    baseMixedTrack?.trackType?.value === 'Mixed';
  const selectedValue = !isMultipleTrack
    ? trackData.trackType ?? TrackType.VideoAndAudio
    : isMixed
      ? undefined
      : baseMixedTrack?.trackType?.value ?? TrackType.VideoAndAudio;

  return (
    <FormGroupWithTooltip tooltipKey="tooltip.track.trackType">
      <Select
        key={`trackType-${trackKey}`}
        id="trackType"
        labelTitle={t('track.trackType')}
        labelClass="col-sm-3 form-label"
        isClearable={false}
        placeholder={isMixed ? t('track.mixed') : ''}
        onChange={(e) =>
          handleInput('trackType', e?.value ?? TrackType.VideoAndAudio)
        }
        initialOption={trackTypeOptions.find(
          (option) => option.value === selectedValue
        )}
        className={isMixed ? 'col-sm-6 mixed-track-type' : 'col-sm-6'}
        isDisabled={disabled}
        isReadOnly={readonly}
        baseOptions={trackTypeOptions}
        multitrack={baseMixedTrack?.trackType}
        showChangeIndicator={!areNewMultipleTracks}
        handleUndo={(value) => handleInput('trackType', value)}
      />
    </FormGroupWithTooltip>
  );
}
